export enum ActionTypes {
  UpgradeEligibility = 'upgradeEligibility',
  UpgradeEligibilityRequest = 'upgradeEligibility.request',
  UpgradeEligibilitySuccess = 'upgradeEligibility.success',
  UpgradeEligibilityFailure = 'upgradeEligibility.failure',
}
